import React from 'react';

function TimeReadingRow({ reading }) {
	return (
		<tr align="right"><td>{reading.pagination}</td><td>{reading.id ? reading.id : 'Registrerar...'}</td><td>{reading.readData.substring(11)}</td></tr>
	);
}
export default TimeReadingRow;